import { useEffect, useState } from "react";
import { AppWebviewLayout } from "./AppWebviewLayout";
import { LoaderView } from "./LoaderView";
import classes from "./InsurelyScreen.module.css";
import { REPLAY_BLOCK_CLASS } from "../../utils/statsig";

// Staging points these at same-origin mocks so it never reaches the real Insurely.
const INSURELY_BOOTSTRAP_SRC =
  import.meta.env.VITE_INSURELY_BOOTSTRAP_SRC ||
  "https://blocks.insurely.com/assets/bootstrap.js";
const INSURELY_IFRAME_SRC =
  import.meta.env.VITE_INSURELY_IFRAME_SRC || "https://blocks.insurely.com/";

interface InsurelyScreenProps {
  isDataLoading: boolean;
}

export function InsurelyScreen({ isDataLoading }: InsurelyScreenProps) {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const showLoader = isDataLoading || !iframeLoaded;

  // Load the Insurely bootstrap script only while this screen is mounted. The
  // script runs with full access to our origin (it can read window.insurely and
  // sessionStorage["customerData"]), so keeping it off every other route limits
  // a CDN compromise to just the collection screen instead of the whole portal.
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = INSURELY_BOOTSTRAP_SRC;
    script.dataset.includeAdvisorHandle = "true";
    script.dataset.includeReferenceId = "true";
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <AppWebviewLayout noPadding>
      <div
        className={`${classes.iframeWrapper} ${
          showLoader ? classes.iframeWrapperLoading : ""
        }`}
      >
        {showLoader && (
          <div className={classes.loaderOverlay}>
            <LoaderView />
          </div>
        )}
        <iframe
          id="insurely-data-aggregation"
          title="Logga in och hämta dina försäkringsuppgifter"
          src={INSURELY_IFRAME_SRC}
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-popups-to-escape-sandbox"
          className={`${classes.iframe} ${REPLAY_BLOCK_CLASS}`}
          onLoad={() => setIframeLoaded(true)}
        />
      </div>
    </AppWebviewLayout>
  );
}
